import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Fri Oct 19 2018
 * @author PKr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { ApplicationConfigurationConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var GeneralConfigurationsLayer =
/*#__PURE__*/
function () {
  function GeneralConfigurationsLayer() {
    _classCallCheck(this, GeneralConfigurationsLayer);

    this.baseUri = CONSTANTS.API.ENDPOINTS.GENERAL_CONFIGURATIONS;
  }

  _createClass(GeneralConfigurationsLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "findAll",
    value: function findAll() {
      var _this = this;

      var findAllPromise = api(this.baseUri).get({
        responseType: 'json'
      }).then(function (response) {
        return _this.getConverter().toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return findAllPromise;
    }
  }]);

  return GeneralConfigurationsLayer;
}();

__decorate([Inject, __metadata("design:type", ApplicationConfigurationConverter)], GeneralConfigurationsLayer.prototype, "converter", void 0);